import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MyAscentListEntry } from 'src/model/my-ascent-list-entry';
import { BoulderDetailsPage } from 'src/pages/boulder-details/boulder-details.page';
import { PipesModule } from 'src/pipes/pipes.module';

@Component({
  standalone: true,
  selector: 'my-ascent-list-entry',
  imports: [IonicModule, FormsModule, CommonModule, PipesModule, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
  <ion-item (click)="showBoulder(ascent.boulderId)">
    <ion-icon *ngIf="!ascent.flash" color="yellow" name="checkmark" size="small" slot="start"></ion-icon>
    <ion-icon *ngIf="ascent.flash" color="yellow" name="flash" size="small" slot="start"></ion-icon>
    <ion-label>
      <ion-text>
        <h2>{{ascent.boulderName}}
          <ion-chip>{{ascent.grade|boulderGrade}}</ion-chip>
        </h2>
        <ion-chip class="points-chip"
                  *ngIf="showPoints">{{ascent.score}} {{"my-ascent-list-component.points" |translate}}</ion-chip>
      </ion-text>
      <ion-note slot="end">{{"my-ascent-list-component.on" |translate}} {{ascent.date|dateFormat}}</ion-note>
    </ion-label>
</ion-item>
  `,
  styleUrls: ['./ascent-list-entry.component.scss'],
})
export class AscentListEntryComponent implements OnInit {

  @Input('ascent')
  ascent: MyAscentListEntry;

  @Input('showPoints')
  showPoints:boolean = false;

  constructor(
    private modalCtrl: ModalController) {
  }

  ngOnInit() {

  }

  async showBoulder(boulderId: string) {
    const modal = await this.modalCtrl.create({
      component: BoulderDetailsPage,
      componentProps: { boulderId: boulderId }
    });
    return await modal.present();
  }


}
